import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "w-100 d-flex justify-content-between" }
const _hoisted_3 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_4 = { class: "card-body pt-9 pb-0" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex flex-wrap flex-sm-nowrap"
}
const _hoisted_6 = {
  key: 1,
  class: "d-flex flex-wrap flex-sm-nowrap"
}
const _hoisted_7 = { class: "me-7 mb-4" }
const _hoisted_8 = { class: "symbol symbol-100px symbol-lg-160px symbol-fixed position-relative img-thumbnail" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "upload-image-button btn btn-icon btn-circle btn-active-color-primary bg-white shadow",
  title: "Upload Image",
  "data-bs-toggle": "modal",
  "data-bs-target": "#draw-image-modal"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil" })
], -1)
const _hoisted_10 = { class: "image-slot" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-body h-20px w-20px" }, null, -1)
const _hoisted_12 = { class: "flex-grow-1" }
const _hoisted_13 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_14 = { class: "d-flex flex-column" }
const _hoisted_15 = { class: "d-flex align-items-center mb-2" }
const _hoisted_16 = {
  href: "#",
  class: "text-gray-900 text-hover-primary fs-2 fw-bold me-1"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-verify fs-1 text-primary" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
    /*#__PURE__*/_createElementVNode("span", { class: "path2" })
  ])
], -1)
const _hoisted_18 = { class: "d-flex flex-wrap fw-semibold fs-6 mb-4 pe-2" }
const _hoisted_19 = {
  href: "#",
  class: "d-flex align-items-center text-gray-500 text-hover-primary me-5 mb-2"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-profile-circle fs-4 me-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path3" })
], -1)
const _hoisted_21 = {
  href: "#",
  class: "d-flex align-items-center text-gray-500 text-hover-primary me-5 mb-2"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-geolocation fs-4 me-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" })
], -1)
const _hoisted_23 = {
  href: "#",
  class: "d-flex align-items-center text-gray-500 text-hover-primary mb-2"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-sms fs-4 me-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" })
], -1)
const _hoisted_25 = { class: "d-flex my-4" }
const _hoisted_26 = ["disabled", "data-kt-indicator"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-check fs-3 d-none" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Open Draw", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_30 = [
  _hoisted_27,
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = ["disabled", "data-kt-indicator"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-check fs-3 d-none" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Close Draw", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_35 = [
  _hoisted_32,
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = ["disabled", "data-kt-indicator"]
const _hoisted_37 = ["disabled", "data-kt-indicator"]
const _hoisted_38 = { class: "d-flex flex-wrap flex-stack" }
const _hoisted_39 = { class: "d-flex flex-column flex-grow-1 pe-8" }
const _hoisted_40 = { class: "d-flex flex-wrap" }
const _hoisted_41 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_42 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-arrow-up fs-3 text-success me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" })
], -1)
const _hoisted_44 = {
  class: "fs-2 fw-bold counted text-center",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$",
  "data-kt-initialized": "1"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold fs-6 text-gray-500 text-center" }, " Members ", -1)
const _hoisted_46 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_47 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-arrow-down fs-3 text-danger me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" })
], -1)
const _hoisted_49 = {
  class: "fs-2 fw-bold counted",
  "data-kt-countup": "true",
  "data-kt-countup-value": "80",
  "data-kt-initialized": "1"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold fs-6 text-gray-500" }, " No of Entries ", -1)
const _hoisted_51 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_52 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-arrow-down fs-3 text-danger me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" })
], -1)
const _hoisted_54 = {
  class: "fs-2 fw-bold counted",
  "data-kt-countup": "true",
  "data-kt-countup-value": "80",
  "data-kt-initialized": "1"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold fs-6 text-gray-500" }, " Draw Entries ", -1)
const _hoisted_56 = { class: "d-flex align-items-center w-200px w-sm-300px flex-column mt-3" }
const _hoisted_57 = {
  key: 0,
  class: "d-flex flex-column justify-content-between w-100 mt-auto mb-2"
}
const _hoisted_58 = { class: "fw-bold fs-6 me-5" }
const _hoisted_59 = { class: "d-flex flex-row gap-2 justify-content-center" }
const _hoisted_60 = { class: "d-flex flex-column time-wrapper border border-gray-300 border-dashed rounded p-3" }
const _hoisted_61 = { class: "text-center time-counter" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Days", -1)
const _hoisted_63 = { class: "d-flex flex-column time-wrapper border border-gray-300 border-dashed rounded p-3" }
const _hoisted_64 = { class: "text-center time-counter" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Hrs", -1)
const _hoisted_66 = { class: "d-flex flex-column time-wrapper border border-gray-300 border-dashed rounded p-3" }
const _hoisted_67 = { class: "text-center time-counter" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Mins", -1)
const _hoisted_69 = { class: "d-flex flex-column time-wrapper border border-gray-300 border-dashed rounded p-3" }
const _hoisted_70 = { class: "text-center time-counter" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Secs", -1)
const _hoisted_72 = { class: "fw-semibold fs-6 text-gray-500 text-center mt-2" }
const _hoisted_73 = {
  key: 1,
  class: "d-flex flex-column justify-content-between w-100 mt-auto mb-2"
}
const _hoisted_74 = { class: "fw-bold fs-6 me-5" }
const _hoisted_75 = { class: "d-flex flex-row gap-2 justify-content-center" }
const _hoisted_76 = { class: "d-flex flex-column time-wrapper border border-gray-300 border-dashed rounded p-3" }
const _hoisted_77 = { class: "text-center time-counter" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Days", -1)
const _hoisted_79 = { class: "d-flex flex-column time-wrapper border border-gray-300 border-dashed rounded p-3" }
const _hoisted_80 = { class: "text-center time-counter" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Hrs", -1)
const _hoisted_82 = { class: "d-flex flex-column time-wrapper border border-gray-300 border-dashed rounded p-3" }
const _hoisted_83 = { class: "text-center time-counter" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Mins", -1)
const _hoisted_85 = { class: "d-flex flex-column time-wrapper border border-gray-300 border-dashed rounded p-3" }
const _hoisted_86 = { class: "text-center time-counter" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Secs", -1)
const _hoisted_88 = { class: "fw-semibold fs-6 text-gray-500 text-center mt-2" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("div", { class: "h-5px mx-3 w-100 bg-light mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "bg-success rounded h-5px",
    role: "progressbar",
    style: {"width":"50%"},
    "aria-valuenow": "50",
    "aria-valuemin": "0",
    "aria-valuemax": "100"
  })
], -1)
const _hoisted_90 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold" }
const _hoisted_91 = ["onClick"]
const _hoisted_92 = { class: "d-flex flex-column mb-10" }
const _hoisted_93 = {
  key: 0,
  class: "d-flex flex-column gap-5"
}
const _hoisted_94 = { class: "w-100 bg-white p-5" }
const _hoisted_95 = { class: "card draw-card" }
const _hoisted_96 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_icon_picture = _resolveComponent("icon-picture")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Chip = _resolveComponent("Chip")!
  const _component_vue_countdown = _resolveComponent("vue-countdown")!
  const _component_Details = _resolveComponent("Details")!
  const _component_Bundles = _resolveComponent("Bundles")!
  const _component_UserEntries = _resolveComponent("UserEntries")!
  const _component_DrawEntries = _resolveComponent("DrawEntries")!
  const _component_Winner = _resolveComponent("Winner")!
  const _component_SendMail = _resolveComponent("SendMail")!
  const _component_Card = _resolveComponent("Card")!
  const _component_ImageUploadModal = _resolveComponent("ImageUploadModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Breadcrumb, { items: _ctx.breadcrumbs }, null, 8, ["items"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (!_ctx.draw?.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_el_skeleton, {
                  rows: 3,
                  animated: ""
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_el_image, {
                      src: _ctx.draw.draw_image_src,
                      class: "align-middle",
                      lazy: "",
                      fit: "contain"
                    }, {
                      error: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_icon_picture)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["src"]),
                    _hoisted_11
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("a", _hoisted_16, [
                          _createTextVNode(_toDisplayString(_ctx.draw?.title) + " ", 1),
                          _createVNode(_component_Chip, {
                            type: _ctx.getStatus(_ctx.draw).type,
                            text: _ctx.getStatus(_ctx.draw).text
                          }, null, 8, ["type", "text"])
                        ]),
                        _hoisted_17
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("a", _hoisted_19, [
                          _hoisted_20,
                          _createTextVNode(" Prize: " + _toDisplayString(_ctx.draw?.prize), 1)
                        ]),
                        _createElementVNode("a", _hoisted_21, [
                          _hoisted_22,
                          _createTextVNode(" Draw Date: " + _toDisplayString(_ctx.formatDate(_ctx.draw?.draw_date)), 1)
                        ]),
                        _createElementVNode("a", _hoisted_23, [
                          _hoisted_24,
                          _createTextVNode(" Draw Time: " + _toDisplayString(_ctx.formatTime(_ctx.draw?.draw_time)), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("a", {
                        href: "javascript:void(0)",
                        class: _normalizeClass(["btn btn-sm btn-secondary me-2", {
                      disabled:
                        _ctx.loadingClose ||
                        ['open', 'close', 'initialized', 'drawn'].includes(
                          _ctx.draw.status
                        ),
                    }]),
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleOpenDraw && _ctx.handleOpenDraw(...args))),
                        disabled: 
                      _ctx.loadingOpen ||
                      ['open', 'close', 'initialized', 'drawn'].includes(
                        _ctx.draw.status
                      )
                    ,
                        "data-kt-indicator": _ctx.loadingOpen ? 'on' : null
                      }, _hoisted_30, 10, _hoisted_26),
                      _createElementVNode("a", {
                        href: "javascript:void(0)",
                        class: _normalizeClass(["btn btn-sm btn-secondary me-2", {
                      disabled:
                        _ctx.loadingClose ||
                        ['close', 'new', 'initialized', 'drawn'].includes(
                          _ctx.draw.status
                        ),
                    }]),
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleCloseDraw && _ctx.handleCloseDraw(...args))),
                        disabled: 
                      _ctx.loadingClose ||
                      ['close', 'new', 'initialized', 'drawn'].includes(
                        _ctx.draw.status
                      )
                    ,
                        "data-kt-indicator": _ctx.loadingClose ? 'on' : null
                      }, _hoisted_35, 10, _hoisted_31),
                      _createElementVNode("a", {
                        href: "javascript:void(0)",
                        class: _normalizeClass(["btn btn-sm btn-secondary me-3", {
                      disabled:
                        _ctx.loadingRun ||
                        ['open', 'new', 'initialized', 'drawn'].includes(
                          _ctx.draw.status
                        ),
                    }]),
                        disabled: 
                      _ctx.loadingRun ||
                      ['open', 'new', 'initialized', 'drawn'].includes(
                        _ctx.draw.status
                      )
                    ,
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleInitializeDraw && _ctx.handleInitializeDraw(...args))),
                        "data-kt-indicator": _ctx.loadingInit ? 'on' : null
                      }, "Initialize Draw", 10, _hoisted_36),
                      _createElementVNode("a", {
                        href: "javascript:void(0)",
                        class: _normalizeClass(["btn btn-sm me-3", {
                      disabled:
                        _ctx.loadingRun ||
                        ['open', 'new', 'close', 'drawn'].includes(_ctx.draw.status),
                      'btn-secondary': [
                        'open',
                        'new',
                        'close',
                        'drawn',
                      ].includes(_ctx.draw.status),
                      'btn-primary': ['initialized'].includes(_ctx.draw.status),
                    }]),
                        disabled: 
                      _ctx.loadingRun ||
                      ['open', 'new', 'close', 'drawn'].includes(_ctx.draw.status)
                    ,
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleRunDraw && _ctx.handleRunDraw(...args))),
                        "data-kt-indicator": _ctx.loadingRun ? 'on' : null
                      }, "Start Draw", 10, _hoisted_37)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            _hoisted_43,
                            _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.membersCount), 1)
                          ]),
                          _hoisted_45
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _hoisted_48,
                            _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.userEntryCount), 1)
                          ]),
                          _hoisted_50
                        ]),
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("div", _hoisted_52, [
                            _hoisted_53,
                            _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.drawEntryCount), 1)
                          ]),
                          _hoisted_55
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      (['initialized', 'drawn'].includes(_ctx.draw.status))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                            _createElementVNode("div", _hoisted_58, [
                              _createElementVNode("div", _hoisted_59, [
                                _createElementVNode("div", _hoisted_60, [
                                  _createElementVNode("div", _hoisted_61, _toDisplayString('00'.toString().padStart(2, '0')), 1),
                                  _hoisted_62
                                ]),
                                _createElementVNode("div", _hoisted_63, [
                                  _createElementVNode("div", _hoisted_64, _toDisplayString('00'.toString().padStart(2, '0')), 1),
                                  _hoisted_65
                                ]),
                                _createElementVNode("div", _hoisted_66, [
                                  _createElementVNode("div", _hoisted_67, _toDisplayString('00'.toString().padStart(2, '0')), 1),
                                  _hoisted_68
                                ]),
                                _createElementVNode("div", _hoisted_69, [
                                  _createElementVNode("div", _hoisted_70, _toDisplayString('00'.toString().padStart(2, '0')), 1),
                                  _hoisted_71
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_72, [
                              (_ctx.draw.status === 'initialized')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode("Draw initialized and ready to start.")
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode("Draw has been completed.")
                                  ], 64))
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_73, [
                            _createElementVNode("div", _hoisted_74, [
                              _createVNode(_component_vue_countdown, { time: _ctx.getCountdown }, {
                                default: _withCtx(({ days, hours, minutes, seconds }) => [
                                  _createElementVNode("div", _hoisted_75, [
                                    _createElementVNode("div", _hoisted_76, [
                                      _createElementVNode("div", _hoisted_77, _toDisplayString(days.toString().padStart(2, '0')), 1),
                                      _hoisted_78
                                    ]),
                                    _createElementVNode("div", _hoisted_79, [
                                      _createElementVNode("div", _hoisted_80, _toDisplayString(hours.toString().padStart(2, '0')), 1),
                                      _hoisted_81
                                    ]),
                                    _createElementVNode("div", _hoisted_82, [
                                      _createElementVNode("div", _hoisted_83, _toDisplayString(minutes.toString().padStart(2, '0')), 1),
                                      _hoisted_84
                                    ]),
                                    _createElementVNode("div", _hoisted_85, [
                                      _createElementVNode("div", _hoisted_86, _toDisplayString(seconds.toString().padStart(2, '0')), 1),
                                      _hoisted_87
                                    ])
                                  ])
                                ]),
                                _: 1
                              }, 8, ["time"])
                            ]),
                            _createElementVNode("div", _hoisted_88, _toDisplayString(_ctx.getDaysRemaining), 1)
                          ])),
                      _hoisted_89
                    ])
                  ])
                ])
              ])),
          _createElementVNode("ul", _hoisted_90, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuTitles, (menu, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: "nav-item mt-2"
              }, [
                _createElementVNode("a", {
                  class: _normalizeClass(["nav-link text-active-primary ms-0 me-10 py-5", { active: _ctx.activeMenu === index }]),
                  href: "javascript:void(0)",
                  onClick: ($event: any) => (_ctx.showTableData(index))
                }, _toDisplayString(menu), 11, _hoisted_91)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_92, [
        _createElementVNode("div", null, [
          _createVNode(_component_Card, null, {
            default: _withCtx(() => [
              (_ctx.loadingDetails)
                ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                    _createElementVNode("div", _hoisted_94, [
                      _createVNode(_component_el_skeleton, {
                        animated: "",
                        row: "5"
                      })
                    ])
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.activeMenu == 'details')
                      ? (_openBlock(), _createBlock(_component_Details, {
                          key: 0,
                          draw: _ctx.draw
                        }, null, 8, ["draw"]))
                      : (_ctx.activeMenu == 'bundles')
                        ? (_openBlock(), _createBlock(_component_Bundles, {
                            key: 1,
                            draw: _ctx.draw,
                            loadingState: _ctx.loading,
                            onLoadData: _ctx.getBundles
                          }, null, 8, ["draw", "loadingState", "onLoadData"]))
                        : (_ctx.activeMenu == 'user_entries')
                          ? (_openBlock(), _createBlock(_component_UserEntries, {
                              key: 2,
                              draw: _ctx.draw,
                              loadingState: _ctx.loading,
                              onLoadData: _ctx.getUserEntries
                            }, null, 8, ["draw", "loadingState", "onLoadData"]))
                          : (_ctx.activeMenu == 'draw_entries')
                            ? (_openBlock(), _createBlock(_component_DrawEntries, {
                                key: 3,
                                draw: _ctx.draw,
                                loadingState: _ctx.loading,
                                onLoadData: _ctx.getDrawEntries
                              }, null, 8, ["draw", "loadingState", "onLoadData"]))
                            : (_ctx.activeMenu == 'winners')
                              ? (_openBlock(), _createBlock(_component_Winner, {
                                  key: 4,
                                  draw: _ctx.draw,
                                  loadingState: _ctx.loading,
                                  onLoadData: _ctx.getWinners
                                }, null, 8, ["draw", "loadingState", "onLoadData"]))
                              : (_ctx.activeMenu == 'send_mail')
                                ? (_openBlock(), _createBlock(_component_SendMail, {
                                    key: 5,
                                    draw: _ctx.draw,
                                    loadingState: _ctx.loading,
                                    onLoadData: _ctx.getTemplates
                                  }, null, 8, ["draw", "loadingState", "onLoadData"]))
                                : _createCommentVNode("", true)
                  ], 64))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("template", null, [
          _createElementVNode("div", _hoisted_95, [
            _createElementVNode("div", _hoisted_96, [
              _createVNode(_component_el_skeleton, {
                rows: 5,
                animated: true
              })
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_ImageUploadModal, {
      "modal-id": `draw-image-modal`,
      image: _ctx.draw?.draw_image_src,
      onRemoveImage: _ctx.handleRemove,
      onUploadImage: _ctx.handleUploadImage
    }, null, 8, ["image", "onRemoveImage", "onUploadImage"])
  ], 64))
}